import { DriverService } from './../../../services/driver.service';
import { AdditionalDriversModel } from './../../../models/Booking/AdditionalDriversModel';
import { SelectedVehicleService } from './../../../services/selectedVehicle.service';
import { GoogleMapPinComponent } from 'src/app/views/booking/google-map-pin/google-map-pin.component';
import { AgencyMapComponent } from './../agency-map/agency-map.component';
import { CustomerEligibilityComponent } from './../customer-eligibility/customer-eligibility.component';
import { LoadingService } from './../../../services/loading.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Customer } from './../../../models/Customer';
import { Vehicle } from './../../../models/Vehicle';
import { OneWayRentalModel } from './../../../models/Booking/OneWayRentalModel';
import { DriverSkillModel } from './../../../models/Booking/DriverSkillModel';
import { CustomerEligibilityEnum, DiscountScopeEnum, PolicyType, PredefinedAdditionalServiceEnum } from './../../../models/enums/BookingEnums';
import { element } from 'protractor';
import { BookingService } from './../../../services/booking.service';
import { LoginModalBodyComponent } from './../login-modal-body/login-modal-body.component';
import { ReviewsModalBodyComponent } from './../../search-location/reviews-modal-body/reviews-modal-body.component';
import { SearchService } from 'src/app/services/search.service';
import { Component, Inject, OnInit, SimpleChanges, OnChanges, ChangeDetectionStrategy, AfterViewInit, ViewChild, OnDestroy, Injector, NgZone, ElementRef } from '@angular/core';
import { faChevronCircleLeft, faChevronCircleRight, faBriefcase, faGasPump, faUser, faMapMarkerAlt, faCar, faKey, faTags, faDollarSign, faRoad, faBatteryHalf, faBan } from '@fortawesome/free-solid-svg-icons';
import { DomSanitizer } from "@angular/platform-browser";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VehicleSearchTypeEnum } from 'src/app/models/enums/VehicleSearchTypeEnum';
import { VehicleReservationCaseDetailsPramModel } from 'src/app/models/VehicleReservationCaseDetailsPramModel';
import { VehicleReservationCaseDetailsModel } from 'src/app/models/VehicleReservationCaseDetailsModel';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { MatStepper } from '@angular/material/stepper';
import { CrossBorderModel } from 'src/app/models/Booking/CrossBorderModel';
import { CampaignsReservationCaseModel } from 'src/app/models/VehicleReservationCaseDetailsModel'
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
import { IconService } from './../../../services/icon.service';
import { AttachmentService } from 'src/app/services/attachment.service';
import { VehicleReservationSearchParm } from 'src/app/models/VehicleReservationSearchParm';
import { DateFormatPipe } from 'src/app/common/pipes/DateFormatPipe';





@Component({
  selector: 'booking-page',
  templateUrl: './booking-page.component.html',
  styleUrls: ['./booking-page.component.css'],

})

export class BookingPageComponent implements OnInit, OnChanges, OnDestroy {

  MakeModelYearSearch: boolean = false;
  vehicleSearch: boolean = false;
  classSearch: boolean = false;

  faBriefcase = faBriefcase;
  faGasPump = faGasPump;
  faUser = faUser;
  faMapMarkerAlt = faMapMarkerAlt;
  faCar = faCar;
  faKey = faKey;
  faTags = faTags;
  faDollarSign = faDollarSign;
  faRoad = faRoad;
  faBatteryHalf = faBatteryHalf;
  faBan = faBan;
  faChevronCircleLeft = faChevronCircleLeft;
  faChevronCircleRight = faChevronCircleRight;

  isRequestingReservationCase: boolean = false;
  vehicle: Vehicle;
  currency;
  duration;
  searchModel: VehicleReservationSearchParm;

  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  fourthFormGroup: FormGroup;

  currentStep: number;
  currentStepData: any;

  bookingData: any;
  driverData: any;
  vehicleReservationCaseDetailsModel: VehicleReservationCaseDetailsModel;

  formControlPrefix = 's_';
  formControlTotalPostfix = '_total';
  formControlTogglePostfix = '_toggle';

  //Customer
  customer: Customer;
  submittedData;
  selectedStepperIndex: number = 0;
  paymentListOfPolicies;

  subscriptions: Subscription[] = [];
  saveAndConfirmMsg: any;
  constructor(
    private selectedVehicleService: SelectedVehicleService,
    private searchService: SearchService,
    private authService: AuthService,
    private _formBuilder: FormBuilder,
    service: SearchService,
    private bookingService: BookingService,
    private router: Router,
    private loadingService: LoadingService,
    private iconService: IconService,
    private attachmnetService: AttachmentService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private _dateFormatPipe: DateFormatPipe,
    private injector: Injector,
    private el: ElementRef,
    private driverService: DriverService,
    private dialog: MatDialog) {
    //this.vehicle = service.getVehicle();
    switch (bookingService.searchAvailableVehicleFilterType) {
      case VehicleSearchTypeEnum.classSearch:
        this.classSearch = true;
        break;
      case VehicleSearchTypeEnum.MakeModelYearSearch:
        this.MakeModelYearSearch = true;
        break;
      case VehicleSearchTypeEnum.vehicleSearch:
        this.vehicleSearch = true;
        break;
      default:
        this.vehicleSearch = true;
        break
    }
    this.currency = service.getCurrency();

    // this.matIconRegistry.addSvgIcon(
    //   "car-gear",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carGearIcon)
    // );
    // this.matIconRegistry.addSvgIcon(
    //   "car-door",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carDoorIcon)
    // );
    this.matIconRegistry.addSvgIcon(
      "timeIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.timeIcon)
    );
    this.matIconRegistry.addSvgIcon(
      "supplierMapIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.supplierMapIcon)
    );


  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })
    this.bookingService.deleteCachedReservationSaveAndConfirm();
  }

  ngOnChanges(changes: SimpleChanges) {



  }

  ngOnInit() {


    this.subscriptions.push(this.selectedVehicleService
      .vehicle
      .subscribe(res => {

        this.vehicle = res;
      }));
    this.subscriptions.push(this.searchService.searchModel.subscribe(res => {
      this.searchModel = res;



    }));

    this.currentStep = 1;
    this.currentStepData = new BehaviorSubject(this.currentStep);

    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['',]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['']
    });

    this.bookingData = new BehaviorSubject(this.secondFormGroup);
    this.subscriptions.push(this.bookingData.subscribe(res => {

      this.secondFormGroup = res;
    }));
    this.submittedData = new BehaviorSubject(false);


    this.driverData = new BehaviorSubject(this.thirdFormGroup);
    this.subscriptions.push(this.driverData.subscribe(res => {


      this.thirdFormGroup = res;
      if (res != null) {
        this.checkElegibility();
        //this.reservationSaveAndConfirm();
        //this.openLogin();
      }


    }));

    this.subscriptions.push(this.bookingService.vehicleReservationCaseDetailsModel.subscribe(res => {


      this.vehicleReservationCaseDetailsModel = res;
      if (res != null) {
        this.paymentListOfPolicies = res.lstPolicyReservationCaseModel;
      }

    }));
    this.subscriptions.push(this.authService.loggedInCustomer.subscribe(res => this.customer = res));



  }

  public get campaignsReservationCaseModel() {
    return this.vehicleReservationCaseDetailsModel != null ? this.vehicleReservationCaseDetailsModel.campaignsReservationCaseModel : null;
  }
  public get membershipModel() {
    return this.vehicleReservationCaseDetailsModel != null ? this.vehicleReservationCaseDetailsModel.membershipModel : null;
  }
  get AttachmentScopesEnum() {
    return AttachmentScopesEnum;
  }
  get AttachmentTypeEnum() {
    return AttachmentTypeEnum;
  }
  get listOfPolicies() {
    if (this.vehicleReservationCaseDetailsModel == null) {
      return null;
    }
    return this.vehicleReservationCaseDetailsModel.lstPolicyReservationCaseModel;
  }
  public get policyType(): typeof PolicyType {
    return PolicyType;
  }



  // Event fired after view is initialized
  @ViewChild('stepper') stepper: MatStepper;
  ngAfterViewInit() {
    //this.stepper.selectedIndex = 1;

    // To avoid "ExpressionChangedAfterItHasBeenCheckedError" error,
    // set the index in setTimeout
    setTimeout(() => {
      this.stepper.selectedIndex = 1;
    }, 0);


    let reservationModel = this.bookingService.getCachedReservationSaveAndConfirm();
    if (reservationModel != null) {

      this.bookingService.updateReservationSaveAndConfirm(reservationModel);
      //If there is saveANdConfritm obj then move to payment
      //ALso in payment if the user back or exist the payment delete the reservationSaveAndConfirmModel
      this.stepper.selectedIndex = 3;
      this.currentStep = 3;
      setTimeout(() => {
        this.stepper.linear = false;
        this.stepper.selectedIndex = 3;
        //this.router.navigate(['./ConfirmationComponent']);
        //this._document.defaultView.location.reload();
      }, 0);
    }
  }




  openDialog() {
    const dialogConfig = new MatDialogConfig();
    this.dialog.open(ReviewsModalBodyComponent, dialogConfig);
  }

  bookNowButton() {
    //Move it to next step (Driver)
    setTimeout(() => {
      this.stepper.selectedIndex = 2;
    }, 0);
  }

  openLogin() {
    this.submittedData.next(true);

    debugger
    //this.secondFormGroup.controls['s_377'].setValidators(Validators.required);
    if (!this.secondFormGroup.valid) {
      const invalidControl = this.el.nativeElement.querySelector('.ng-invalid');

      if (invalidControl) {
        invalidControl.focus();
        invalidControl.scrollIntoView();
      }
      return
    }

    //Todo: update the isLoggedIn to check userObject
    if (this.authService.isLoggedIn()) {
      //Move it to next step (Driver)
      setTimeout(() => {
        this.stepper.selectedIndex = 2;

      }, 0);
      this.currentStep = 2;
      this.currentStepData.next(this.currentStep);
      //this.reservationSaveAndConfirm();

    }
    else {
      const dialogConfig = new MatDialogConfig();
      let dialogRef = this.dialog.open(LoginModalBodyComponent, { panelClass: 'LoginModal' });
      dialogRef.afterClosed().subscribe(
        data => {
          if (this.authService.isLoggedIn()) {
            //Move it to next step (Driver)
            setTimeout(() => {
              this.stepper.selectedIndex = 2;

            }, 0);
            this.currentStep = 2;
            this.currentStepData.next(this.currentStep);
            //this.reservationSaveAndConfirm();
          }
        }
      );
    }

  }
  isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }

  checkElegibility() {
    let customer = JSON.parse(this.authService.GetCustomerStorage());
    let newCustomerDOB = this.thirdFormGroup.controls['DateofBirth'].value;

    let checkElegibilityReqModel = {
      agencyId: this.searchModel.AgencyID,
      customerID: customer.customerID,
      DOB: newCustomerDOB,
    }

    this.bookingService
      .checkCustomerElegibility(checkElegibilityReqModel)
      .subscribe(res => {

        if (res != null && res.length > 0) { //&&!this.isEmptyOrSpaces(res.message)
          this.openEligibility(res);
          //Terminate the function call and not procced the save
          return;
        }

        this.reservationSaveAndConfirm();
      })
  }
  reservationSaveAndConfirm() {


    if (this.searchModel != null && this.vehicle != null) {

    }


    let req = this.getReservationSaveRequestModel();


    this.saveAndConfirmMsg = null;
    this.bookingService.reservationSaveAndConfirm(req).subscribe(res => {






      if (res != null && res["success"]) {

        let updatedCustomer = this.getCustomerModel();

        this.authService.saveCustomer(updatedCustomer)
        this.authService.cachedCustomer(updatedCustomer);
        this.bookingService.updateReservationSaveAndConfirm(res);

        this.stepper.selectedIndex = 3;
        //Move it to next step (Payment)
        setTimeout(() => {
          this.stepper.linear = false;
          this.stepper.selectedIndex = 3;
          //this.router.navigate(['./ConfirmationComponent']);
          //this._document.defaultView.location.reload();
        }, 0);

      }
      else {
        this.saveAndConfirmMsg = res["msg"];
      }

    })
  }

  getReservationSaveRequestModel() {
    //Todo: create request model ,, high priority
    let vehicleReservationCaseDetailsPram = {
      agencyID: this.searchModel.AgencyID,
      startDateString: this.searchModel.StartDateString,
      classID: this.vehicle.classID,
      makeID: this.vehicle.makeID,
      modelID: this.vehicle.modelID,
      year: this.vehicle.year,
      vehicleID: this.vehicle.vehicleID,
      contractTypeID: this.vehicle.contractTypeID,
      startTimeString: this.searchModel.StartTimeString,
      endDateString: this.searchModel.EndDateString,
      endTimeString: this.searchModel.EndTimeString,
      membershipID: this.vehicle.membershipID,
      campaignID: this.vehicle.campaignID,
      pricingRuleID: this.vehicle.pricingRuleID,
      dropOffLocationID: this.getReqDropOffLocationID(),
      userSearchLattitude:this.searchModel.Latitude,
      userSearchLongitude:this.searchModel.Longitude
    }

    let req = vehicleReservationCaseDetailsPram;


    //IF he arrived at the payment step and then go back
    //We send the generated CaseID
    //Note: if he exist the booking page we removing the CachedBookingCaseID in BookNow Button in search-vehicle-page
    let bookingCaseID = this.bookingService.getCachedBookingCaseID();
    if (bookingCaseID != null) {
      req["CaseID"] = bookingCaseID;
    }
    let user = JSON.parse(this.authService.GetUserStorage());
    let customer = JSON.parse(this.authService.GetCustomerStorage());
    req['CustomerName'] = user.email;
    req['CustomerID'] = customer.customerID;
    req['customerModel'] = this.getCustomerModel();
    req['PricingRuleID'] = this.vehicle.pricingRuleID;
    //Todo: DroppOffLocation shoould be dynamic - high priority


    let additionalServices = this.vehicleReservationCaseDetailsModel.lstAdditionalServiceReservationCase;
    req['lstAdditionalServiceReservationCasePramModel'] = this.buildLstAdditionalServiceReservationObject(additionalServices);
    let oneWayRental = additionalServices.filter(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService)[0];

    if (oneWayRental != null) {
      let controls = this.secondFormGroup.controls;
      let value = controls[this.formControlPrefix + oneWayRental.additionalServiceID].value;
      let toggle = controls[this.formControlPrefix + oneWayRental.additionalServiceID + this.formControlTogglePostfix].value
      if (toggle && value != null) {
        req['DropOffLocationID'] = value.returnAgencyID;
        req['DropOffLocationTypeID'] = value.agencyReturnLocationTypeID;
      }

    }


    return req;
  }

  getReqDropOffLocationID() {

    let id = this.searchModel.ToAgencyID == null ? this.searchModel.AgencyID : this.searchModel.ToAgencyID;
    let additionalServices = this.vehicleReservationCaseDetailsModel.lstAdditionalServiceReservationCase;
    if (additionalServices != null) {
      let oneWayRentalService = additionalServices.filter(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService)[0]
      if (oneWayRentalService != null) {
        let controls = this.secondFormGroup.controls;
        let toggle = controls[this.formControlPrefix + oneWayRentalService.additionalServiceID + this.formControlTogglePostfix].value;
        if (!toggle && this.searchModel.AgencyID != this.searchModel.ToAgencyID) {
          this.searchModel.ToAgencyID = this.searchModel.AgencyID;
          id = this.searchModel.AgencyID;
        }
      }

    }


    return id;
  }

  buildLstAdditionalServiceReservationObject(additionalServices) {

    //let additionalServices = this.vehicleReservationCaseDetailsModel.lstAdditionalServiceReservationCase;


    let controls = this.secondFormGroup.controls;
    let res = [];
    additionalServices.forEach(element => {

      let req = {};
      let toggle = controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix];
      let value = controls[this.formControlPrefix + element.additionalServiceID].value;
      if (toggle.value && value != null) {
        req['PredefinedAdditionalServiceID'] = element.predefinedAdditionalServiceID;
        req['AdditionalServiceID'] = element.additionalServiceID;
        req['AdditionalServiceTypeID'] = element.additionalServiceTypeID;
        switch (element.predefinedAdditionalServiceID) {
          case PredefinedAdditionalServiceEnum.Drivers:
            /* let driverSkills = value as DriverSkillModel[];
            req[element.predefinedAdditionalServiceID] = driverSkills.map(o => o.driverSkillID); */
            req['Value'] = value;
            break;
          case PredefinedAdditionalServiceEnum.OneWayRentalService:
            /*  let oneWayRental = value as OneWayRentalModel;
             req[element.predefinedAdditionalServiceID] = oneWayRental.returnAgencyID; */
            req['Value'] = value

            break
          case PredefinedAdditionalServiceEnum.AdditionalDrivers:
            let driversModel: AdditionalDriversModel[];
            for (let i = 0; i < value; i++) {
              if (driversModel == null) {
                driversModel = [];
              }
              let driverModel: AdditionalDriversModel = {
                ID: 1,
              }
              driversModel.push(driverModel);
            }
            req['Value'] = driversModel;
            break;
          case PredefinedAdditionalServiceEnum.RentalDelivery:


            req['Value'] = value
            break
          case PredefinedAdditionalServiceEnum.CrossingBoarders:
            let borderObj = controls[this.formControlPrefix + element.additionalServiceID + '_Borders'];
            let _crossBorders = this.prepareCrossBorders(borderObj);
            req['Value'] = _crossBorders;
            break
          default:
            req['Value'] = value;
            break
        }



        req['Value'] = JSON.stringify(req['Value']);

        res.push(req);
      }

    });


    return res;
  }

  getCustomerModel() {
    /*     let customer:Customer={
        firstName:this.thirdFormGroup.controls['firstName'].value,
        secondName:this.thirdFormGroup.controls['secondName'].value,
        familyName:this.thirdFormGroup.controls['thirdName'].value,
        dob:this.thirdFormGroup.controls['DateofBirth'].value,
        mobile1:this.thirdFormGroup.controls['mobileCode'].value+this.thirdFormGroup.controls['mobileNum'].value;
        primaryEmail:this.thirdFormGroup.controls['email'].value,
        }; */
    let _customer = this.customer;

    _customer.firstName = this.thirdFormGroup.controls['firstName'].value;
    _customer.secondName = this.thirdFormGroup.controls['secondName'].value;
    _customer.familyName = this.thirdFormGroup.controls['thirdName'].value;
    _customer.dob = this.thirdFormGroup.controls['DateofBirth'].value;

    _customer.dobFormated = this._dateFormatPipe.transform(new Date(this.thirdFormGroup.controls['DateofBirth'].value));
    _customer.mobile1 = this.thirdFormGroup.controls['mobileNum'].value.number;
    _customer.primaryEmail = this.thirdFormGroup.controls['email'].value;
    _customer.locationID = this.thirdFormGroup.controls['locationID'].value;

    let age = this.driverService.calculateAgeFromBirthdate(this.thirdFormGroup.controls['DateofBirth'].value);
    if (_customer.age != age) {
      _customer.age = age;
    }
    return _customer;
  }


  debug() {

    this.thirdFormGroup;
  }

  prepareCrossBorders(bordersForm) {
    {
      let _crossBorders: CrossBorderModel[] = [];
      bordersForm.controls.forEach(fg => {

        let formGroup = fg as FormGroup;
        let border = formGroup.controls['BorderObj'].value as CrossBorderModel;
        _crossBorders.push(border);
      });
      return _crossBorders;
    }
  }

  NavigateToSearchResults() {

    //IF the current tab is payment and user click back THEN delete cached reservation
    if (this.stepper.selectedIndex == 3) {
      this.bookingService.deleteCachedReservationSaveAndConfirm();

    }

    if (this.stepper.selectedIndex - 1 > 0) {

      this.stepper.linear = false;
      this.stepper.selectedIndex = this.stepper.selectedIndex - 1;
    }
    else {
      // this.router.navigate(['./searchByLocation']);

      if (this.searchModel.isFromFavorite) {
        this.router.navigate(['/My-Favourits']);
      }
      else {
        //Test a fix for the stocking issue
        const routerService = this.injector.get(Router);
        const ngZone = this.injector.get(NgZone);
        ngZone.run(() => {
          routerService.navigate(['./searchByLocation']);
        });
      }

    }
  }


  openEligibility(customerElegibility) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { customerElegibility: customerElegibility, vehicleReservationCaseDetailsModel: this.vehicleReservationCaseDetailsModel };
    let dialogRef = this.dialog.open(CustomerEligibilityComponent, dialogConfig);

  }

  openAgencyMap() {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      isDraggable: false,
      position: {
        latitude: this.vehicleReservationCaseDetailsModel.latitude,
        longitude: this.vehicleReservationCaseDetailsModel.longitude,
        address: this.vehicleReservationCaseDetailsModel.summaryChargePickUpLocationAddress
      }
    }
    this.dialog.open(GoogleMapPinComponent, dialogConfig);
  }

  stepperSelectionChange() {

    this.selectedStepperIndex = this.stepper.selectedIndex + 1;

  }

  openMembershipLandingPage() {
    //window.location.href=this.vehicleReservationCaseDetailsModel.membershipModel.landingPageURL;
  }
  openCampaignLandingPage() {

    let landingPage = this.vehicleReservationCaseDetailsModel.campaignsReservationCaseModel.landingPageURL;
    //window.open(landingPage);
    if (landingPage != null) {
      if (landingPage.includes("https://") || landingPage.includes("http://")) {
        window.open(landingPage, '_blank');
      }
      else {
        landingPage = "https://" + landingPage;
        window.open(landingPage, '_blank');
      }
    }
  }

}
